import {
    AIAssistantLauncher,
    PANEL_MODES,
    useAIAssistant,
} from '/b2b/common/components/AIAssistant';

import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import makeStyles from '@mui/styles/makeStyles';
import styles from './AIAssistantFab.styles';

const useStyles = makeStyles(styles);

const AIAssistantFab = props => {
    const { expandOnHover = false } = props;
    const classes = useStyles(props);
    const { panelMode } = useAIAssistant();
    const isOpen =
        panelMode === PANEL_MODES.SIDEBAR ||
        panelMode === PANEL_MODES.WIDGET ||
        panelMode === PANEL_MODES.FULLSCREEN;

    if (isOpen) {
        return null;
    }

    return (
        <Box className={classNames(classes.root, { [classes.expandable]: expandOnHover })}>
            <AIAssistantLauncher />
        </Box>
    );
};

AIAssistantFab.propTypes = {
    expandOnHover: PropTypes.bool,
};

export default AIAssistantFab;
